const callAppCmd = (
  event: string,
  params: string | Record<string, unknown> | undefined,
  callback: (code: number, ret: string) => void
) => {
  const external = (window as any).external || {};
  const sid = external.GetSID ? external.GetSID(window) : '';
  const module = event === 'ReloginByManual' ? 'loginenrol' : '360Saas';
  console.log('AppCmd params: ', sid, module, event, JSON.stringify(params));
  if (!external.AppCmd) {
    return;
  }
  external.AppCmd(
    sid,
    module,
    event,
    typeof params === 'string' ? params : JSON.stringify(params),
    event === 'onClose' ? 'saas' : '',
    callback
  );
};

const callClient = <T extends Record<string, unknown>>(
  event: string,
  params: string | Record<string, unknown> | undefined,
  config = { timeout: 10000 }
) => {
  const start = Date.now();
  return Promise.race([
    new Promise<{ data: T }>((resolve, reject) => {
      callAppCmd(event, params, (code, ret) => {
        console.log('Call client 耗时：', Date.now() - start);
        console.log('客户端回调的参数：', code, ret);
        let result = { data: {} } as { data: T };
        let payload: { data: string } = { data: '' };
        try {
          payload = JSON.parse(ret);
          result = { data: JSON.parse(payload.data) };
        } catch {
          console.log('Parse error, ', ret);
        }
        if (code === 0) {
          return resolve(result);
        }
        return reject({ errno: 1, data: payload.data });
      });
    }),
    new Promise<{ data: T }>((resolve, reject) => {
      setTimeout(() => {
        reject({ code: -1, message: 'timeout' });
      }, config.timeout);
    }),
  ]);
};

export interface UserInfo {
  company_name: string;
  company_logo: string;
  Q: string;
  T: string;
}

export interface LoginInfo {
  token: string;
  pin: string;
  userInfo: UserInfo;
}

// 从客户端获取登录信息
export function getLoginInfo() {
  // @ts-ignore
  return import.meta.env.MODE === 'dev'
    ? new Promise<{ data: LoginInfo }>(resolve => {
        resolve({
          data: {
            // @ts-ignore
            pin: import.meta.env.VITE_DEV_PIN,
            // @ts-ignore
            token: import.meta.env.VITE_DEV_ACCESS_TOKEN,
            userInfo: {
              company_logo: 'https://p5.ssl.qhimg.com/t110b9a9301e119e103b0793c40.png',
              company_name: '0000510test',
              // @ts-ignore
              Q: import.meta.env.VITE_DEV_COOKIE_Q,
              // @ts-ignore
              T: import.meta.env.VITE_DEV_COOKIE_T,
            },
          },
        });
      })
    : callClient<{ token: string; pin: string; userInfo: { Q: string; T: string } }>(
        'GetLoginInfo',
        undefined
      );
}

// 客户端强制刷新token
export function getLoginInfoByForceRefresh() {
  // @ts-ignore
  return import.meta.env.MODE === 'dev'
    ? new Promise<{ data: { token: string; pin: string; userInfo: UserInfo } }>((resolve) => {
        window.setTimeout(() => {
          resolve({
            data: {
              // @ts-ignore
              pin: import.meta.env.VITE_DEV_PIN,
              // @ts-ignore
              token: import.meta.env.VITE_DEV_ACCESS_TOKEN,
              userInfo: {
                company_logo: 'https://p5.ssl.qhimg.com/t110b9a9301e119e103b0793c40.png',
                company_name: '0000510test',
                // @ts-ignore
                Q: import.meta.env.VITE_DEV_COOKIE_Q,
                // @ts-ignore
                T: import.meta.env.VITE_DEV_COOKIE_T,
              },
            },
          })
        }, 1000)
      })
    : callClient<{ token: string; pin: string; userInfo: UserInfo }>('GetLoginInfo', { flag: 1 })
}

export function invokeLoginModal() {
  callClient('ReloginByManual', 'config');
}
